/**
 * Site JavaScript
 *
 * This file is bundled by esbuild and output to public/assets/js/main.js.
 * The base template includes it via <script src="/assets/js/main.js" defer>.
 *
 * Build:  pnpm run build
 * Watch:  pnpm run watch  (auto-rebuilds on change)
 */

import { launchGame } from "./game";

function ready(fn: () => void) {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

ready(() => {
  if (document.getElementById("game-canvas")) {
    launchGame("game-canvas");
  }
});
